import 'angular';

import { SettingsStates }             from './settings.states.ajs';
import { TaxGroupsCtrl }              from './settings.tax-groups';

angular.module('workshop.settings', [])
  .config(SettingsStates)
  .controller('TaxGroupsCtrl', TaxGroupsCtrl);